module.exports = __webpack_public_path__ + "img/SK31340890.320ac4d1.png";